<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="createUser"
  >
    <v-card>
      <v-card-title primary-title>
        Uppdatera användare
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                filled
                v-model="model.first_name"
                label="Förnamn"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                filled
                v-model="model.last_name"
                :rules="[rules.required]"
                label="Efternamn"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                filled
                v-model="model.email"
                :rules="[rules.required, rules.email]"
                label="Email"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                filled
                label="Nytt lösenord"
                type="password"
                v-model="model.password"
                placeholder="Skriv in nytt lösenord"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                filled
                label="Nytt lösenord igen"
                type="password"
                v-model="newPasswordConfirm"
                placeholder="Skriv in nytt lösenord igen"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="error--text" v-for="(error, $i) in errors" :key="$i">
                {{ error }}
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-combobox
                v-model="model.access_rights"
                :items="sortedAccesses"
                label="Behörigheter"
                item-text="name_se"
                :item-value="x => x.id"
                multiple
                chips
              ></v-combobox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn tile text @click="close" :disabled="pendingUpdate">
          Avbryt
        </v-btn>
        <v-btn tile color="primary" text type="submit" :loading="pendingUpdate">
          Uppdatera
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import rules from '@/common/validationRules.js'
import gql from 'graphql-tag'
import orderBy from 'lodash.orderby'

export default {
  name: 'UserUpdate',

  data: () => ({
    pendingUpdate: false,
    rules,
    roles: [],
    valid: true,
    newPasswordConfirm: '',
    model: {
      access_rights: [],
      email: '',
      first_name: '',
      last_name: '',
      password: ''
    }
  }),

  apollo: {
    accesses: {
      query: gql`
        query {
          accesses {
            id
            name_se
          }
        }
      `
    }
  },

  props: {
    user: Object
  },

  created() {
    this.model.email = this.user.email
    this.model.first_name = this.user.first_name
    this.model.last_name = this.user.last_name
    this.model.access_rights = this.user.access_rights.map(x => ({
      name_se: x.name_se,
      id: x.access_id
    }))
  },

  computed: {
    sortedAccesses() {
      return orderBy(this.accesses || [], ['name_se'], ['asc'])
    },

    errors() {
      const errors = []

      if (this.model.password !== this.newPasswordConfirm) {
        errors.push('Lösenorden måste vara identiska')
      }

      return errors
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async createUser() {
      const isValid = await this.$refs.form.validate()

      if (!isValid || this.errors.length) return

      this.pendingUpdate = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation updateUser($id: Int!, $payload: UpdateUserInput!) {
            updateUser(id: $id, payload: $payload)
          }
        `,

        variables: {
          payload: {
            ...this.model,
            access_rights: this.model.access_rights.map(x => x.id)
          },
          id: parseInt(this.user.id, 10)
        }
      })

      this.pendingUpdate = false
      this.$emit('confirm')
    }
  }
}
</script>
